export const SupportAndQueris = ({ fill = "#00bfff", size = 33, ...props }) => (
  <svg
    id="LINE"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 57 57"
    width={size}
    height={size}
    {...props}
  >
    <g>
      <path
        fill={fill}
        d="M50.5,57H6.5c-3.58,0-6.5-2.92-6.5-6.5v-5.55c0-.83.67-1.5,1.5-1.5h54c.83,0,1.5.67,1.5,1.5v5.55c0,3.58-2.92,6.5-6.5,6.5ZM3,46.45v4.05c0,1.93,1.57,3.5,3.5,3.5h44c1.93,0,3.5-1.57,3.5-3.5v-4.05H3Z"
      />
      <path
        fill={fill}
        d="M51.97,46.45c-.83,0-1.5-.67-1.5-1.5v-27.79c0-.83-.67-1.5-1.5-1.5h-2.6c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h2.6c2.48,0,4.5,2.02,4.5,4.5v27.79c0,.83-.67,1.5-1.5,1.5Z"
      />
      <path
        fill={fill}
        d="M5.03,46.45c-.83,0-1.5-.67-1.5-1.5v-27.79c0-2.48,2.02-4.5,4.5-4.5h7.81c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-7.81c-.83,0-1.5.67-1.5,1.5v27.79c0,.83-.67,1.5-1.5,1.5Z"
      />
      <path
        fill={fill}
        d="M34.46,51.89h-11.92c-1.59,0-3.08-.85-3.88-2.23l-2.32-3.96c-.27-.46-.27-1.04,0-1.5.27-.47.76-.75,1.3-.75h21.74c.54,0,1.03.29,1.3.75.27.47.26,1.04,0,1.5l-2.32,3.96c-.8,1.37-2.29,2.23-3.88,2.23h-.02ZM20.24,46.45l1,1.71c.27.46.76.74,1.29.74h11.92c.53,0,1.03-.28,1.29-.74l1-1.71h-16.51.01Z"
      />
      <g>
        <g>
          <path
            fill={fill}
            d="M16.36,28.74h-6.23c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.23c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
          />
          <path
            fill={fill}
            d="M16.36,34.7h-6.23c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.23c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
          />
          <path
            fill={fill}
            d="M16.36,40.66h-6.23c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.23c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
          />
        </g>
        <g>
          <path
            fill={fill}
            d="M46.86,28.74h-6.23c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.23c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
          />
          <path
            fill={fill}
            d="M46.86,34.7h-6.23c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.23c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
          />
          <path
            fill={fill}
            d="M46.86,40.66h-6.23c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.23c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
          />
        </g>
      </g>
      <path
        fill={fill}
        d="M33.88,34.7h-10.77c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h10.77c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
      />
      <path
        fill={fill}
        d="M33.88,40.66h-10.77c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h10.77c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
      />
    </g>
    <g>
      <path
        fill={fill}
        d="M28.5,28.32c-7.81,0-14.16-6.35-14.16-14.16S20.69,0,28.5,0s14.16,6.35,14.16,14.16-6.35,14.16-14.16,14.16ZM28.5,3c-6.15,0-11.16,5.01-11.16,11.16s5.01,11.16,11.16,11.16,11.16-5.01,11.16-11.16-5.01-11.16-11.16-11.16Z"
      />
      <g>
        <path
          fill={fill}
          d="M28.35,18.32c-.83,0-1.5-.67-1.5-1.5v-1c0-1.47.88-2.78,2.23-3.34.72-.3,1.38-1.13,1.12-2.24-.15-.68-.71-1.23-1.39-1.39-.61-.14-1.2-.01-1.66.36s-.72.91-.72,1.5c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5c0-1.5.67-2.9,1.85-3.84s2.7-1.28,4.2-.94c1.8.41,3.23,1.84,3.64,3.64.54,2.37-.68,4.75-2.9,5.67-.23.1-.38.32-.38.57v1c0,.83-.67,1.5-1.5,1.5h.01Z"
        />
        <path
          fill={fill}
          d="M28.35,22.52c-.39,0-.78-.16-1.06-.44s-.44-.66-.44-1.06.16-.78.44-1.06c.56-.56,1.56-.56,2.12,0,.28.28.44.67.44,1.06s-.16.79-.44,1.06c-.28.28-.66.44-1.06.44Z"
        />
      </g>
    </g>
  </svg>
);

export const AccountSettings = ({ fill = "#00bfff", size = 33, ...props }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 458.67 458.67"
    width={size}
    height={size}
    {...props}
  >
    <g id="Icon">
      <path
        fill={fill}
        d="M218.67,405.61H36.27c-1.13,0-2.22-.47-3.01-1.26-.81-.81-1.26-1.88-1.26-3.01v-30.95c0-17.71,12.65-33.32,32.15-46.59,34.82-23.77,91.16-38.74,154.52-38.74,8.83,0,16-7.17,16-16s-7.17-16-16-16c-70.87,0-133.61,17.73-172.57,44.29C16.38,317.61,0,343.36,0,370.39v30.95c0,9.6,3.82,18.84,10.62,25.64,6.81,6.78,16.02,10.62,25.64,10.62h182.4c8.83-.02,16-7.19,16-16.02s-7.17-16-16-15.98h0Z"
      />
      <path
        fill={fill}
        d="M218.67,0c-64.77,0-117.33,52.57-117.33,117.33s52.57,117.33,117.33,117.33,117.33-52.57,117.33-117.33S283.43,0,218.67,0ZM218.67,32c47.1,0,85.33,38.23,85.33,85.33s-38.23,85.33-85.33,85.33-85.33-38.23-85.33-85.33,38.23-85.33,85.33-85.33Z"
      />
      <path
        fill={fill}
        d="M346.67,270.68c-41.94,0-75.99,34.05-75.99,75.99s34.05,76.01,75.99,76.01,76.01-34.07,76.01-76.01-34.07-75.99-76.01-75.99ZM346.67,302.68c24.28,0,44.01,19.71,44.01,43.99s-19.73,44.01-44.01,44.01-44.01-19.73-44.01-44.01,19.73-43.99,44.01-43.99Z"
      />
      <path
        fill={fill}
        d="M362.67,286.66v-35.99c0-8.83-7.17-16-16-16s-16,7.17-16,16v36.01c0,8.81,7.17,16,16,16,8.83-.02,16-7.19,16-16.02h0Z"
      />
      <path
        fill={fill}
        d="M400.41,315.56l25.45-25.47c6.25-6.23,6.25-16.38,0-22.61-6.23-6.25-16.38-6.25-22.61,0l-25.47,25.45c-6.23,6.25-6.23,16.38,0,22.63,6.25,6.23,16.38,6.23,22.63,0h0Z"
      />
      <path
        fill={fill}
        d="M406.66,362.67h36.01c8.83,0,16-7.17,16-16s-7.17-16-16-16h-36.01c-8.81,0-15.98,7.17-15.98,16-.02,8.83,7.17,16,15.98,16Z"
      />
      <path
        fill={fill}
        d="M377.77,400.41l25.47,25.45c6.23,6.25,16.38,6.25,22.61,0,6.25-6.23,6.25-16.38,0-22.61l-25.45-25.47c-6.25-6.23-16.38-6.23-22.63,0-6.23,6.25-6.23,16.38,0,22.63h0Z"
      />
      <path
        fill={fill}
        d="M330.67,406.66v36.01c0,8.83,7.17,16,16,16s16-7.17,16-16v-36.01c0-8.81-7.17-15.98-16-16-8.83,0-16,7.19-16,16Z"
      />
      <path
        fill={fill}
        d="M292.93,377.77l-25.45,25.47c-6.25,6.23-6.25,16.38,0,22.61,6.23,6.25,16.38,6.25,22.61,0l25.47-25.45c6.23-6.25,6.23-16.38,0-22.63-6.25-6.23-16.38-6.23-22.63,0h0Z"
      />
      <path
        fill={fill}
        d="M286.66,330.67h-35.99c-8.83,0-16,7.17-16,16s7.17,16,16,16h35.99c8.83,0,16.02-7.17,16-16,0-8.83-7.17-16-16-16Z"
      />
      <path
        fill={fill}
        d="M315.56,292.93l-25.47-25.45c-6.23-6.25-16.38-6.25-22.61,0-6.25,6.23-6.25,16.38,0,22.61l25.45,25.47c6.25,6.23,16.38,6.23,22.63,0,6.23-6.25,6.23-16.38,0-22.63Z"
      />
    </g>
  </svg>
);
export const LogoutSvgIcon = ({ fill = "#00bfff", size = 28, ...props }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500.92 448.86"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={fill}
      d="M383.74,336.98c12.57,12.43,12.68,32.69.25,45.25-42.49,42.96-99.16,66.63-159.57,66.63s-116.31-23.35-158.7-65.73C23.34,340.74,0,284.38,0,224.43S23.34,108.12,65.73,65.73C108.12,23.35,164.48,0,224.43,0s117.08,23.66,159.57,66.63c12.43,12.57,12.31,32.83-.25,45.25s-32.83,12.31-45.25-.25c-30.37-30.71-70.88-47.63-114.06-47.63-88.46,0-160.43,71.97-160.43,160.43s71.97,160.43,160.43,160.43c43.18,0,83.69-16.92,114.06-47.63,12.43-12.57,32.69-12.68,45.25-.25h0ZM491.54,201.8l-62.83-62.83c-12.5-12.5-32.76-12.5-45.26,0s-12.5,32.76,0,45.26l8.2,8.2h-167.23c-17.67,0-32,14.33-32,32s14.33,32,32,32h167.23l-8.2,8.2c-12.5,12.5-12.5,32.76,0,45.26,6.25,6.25,14.44,9.37,22.63,9.37s16.38-3.12,22.63-9.37l62.83-62.83c12.5-12.5,12.5-32.76,0-45.25h0Z"
    />
  </svg>
);
export const AdminControlSvgIcon = ({
  fill = "#00bfff",
  size = 28,
  ...props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 435.67 494.04"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={fill}
      d="M434.58,379.37c-.52-3.42-3.46-5.96-6.92-5.96h-8.54c-2.05-8.26-5.3-16.08-9.69-23.36l6.04-6.05c2.45-2.45,2.73-6.33.67-9.11-5.92-7.99-12.97-15.04-20.96-20.96-2.79-2.06-6.66-1.78-9.12.68l-6.03,6.03c-7.31-4.4-15.12-7.64-23.35-9.67v-8.53c0-3.46-2.53-6.41-5.96-6.92-9.66-1.46-20.04-1.46-29.7,0-3.42.52-5.96,3.46-5.96,6.92v8.53c-8.22,2.04-16.04,5.27-23.35,9.67l-6.03-6.03c-2.45-2.45-6.32-2.74-9.11-.68-8,5.9-15.07,12.96-21,20.97-2.06,2.79-1.78,6.66.68,9.12l6.05,6.05c-4.39,7.27-7.63,15.09-9.68,23.35h-8.54c-3.46,0-6.41,2.53-6.92,5.96-.73,4.83-1.1,9.83-1.1,14.85s.37,10.02,1.1,14.83c.52,3.42,3.46,5.95,6.92,5.95h8.54c2.05,8.26,5.3,16.08,9.68,23.35l-6.05,6.05c-2.45,2.45-2.74,6.33-.68,9.12,5.93,8.01,13,15.07,21,20.97,2.79,2.06,6.66,1.77,9.11-.68l6.02-6.02c7.28,4.39,15.1,7.63,23.35,9.67v8.55c0,3.48,2.56,6.43,6,6.93,5.01.72,9.99,1.09,14.81,1.09s9.8-.37,14.81-1.09c3.44-.5,6-3.45,6-6.93v-8.54c8.24-2.05,16.06-5.29,23.35-9.69l6.03,6.03c2.45,2.45,6.33,2.74,9.12.68,7.99-5.92,15.04-12.97,20.96-20.96,2.06-2.78,1.78-6.66-.67-9.11l-6.04-6.05c4.39-7.28,7.63-15.1,9.69-23.36h8.54c3.46,0,6.4-2.53,6.92-5.95.73-4.81,1.1-9.8,1.1-14.83s-.37-10.01-1.1-14.85v-.02ZM421.41,400.99h-7.96c-3.39,0-6.3,2.43-6.89,5.78-1.84,10.34-5.82,19.93-11.82,28.5-1.95,2.78-1.62,6.56.78,8.96l5.63,5.65c-2.95,3.45-6.16,6.66-9.61,9.61l-5.62-5.62c-2.4-2.4-6.18-2.73-8.96-.79-8.62,6.02-18.21,10-28.51,11.83-3.34.59-5.78,3.5-5.78,6.89v7.95c-4.64.37-9.06.37-13.61,0v-7.98c0-3.4-2.44-6.31-5.79-6.9-10.31-1.81-19.9-5.78-28.49-11.79-2.78-1.95-6.56-1.62-8.97.78l-5.63,5.63c-3.45-2.94-6.67-6.15-9.62-9.61l5.65-5.65c2.4-2.4,2.73-6.19.78-8.97-6.01-8.57-9.99-18.16-11.82-28.5-.59-3.34-3.5-5.78-6.89-5.78h-7.96c-.17-2.23-.26-4.5-.26-6.77s.09-4.55.26-6.8h7.96c3.39,0,6.3-2.43,6.89-5.78,1.84-10.34,5.82-19.93,11.82-28.5,1.95-2.78,1.62-6.57-.78-8.97l-5.65-5.65c2.95-3.46,6.17-6.67,9.62-9.61l5.63,5.63c2.4,2.4,6.17,2.73,8.96.79,8.64-6.03,18.23-10,28.5-11.8,3.35-.59,5.79-3.5,5.79-6.9v-7.96c4.49-.35,9.11-.35,13.61,0v7.96c0,3.4,2.44,6.31,5.79,6.9,10.26,1.8,19.85,5.77,28.5,11.8,2.78,1.94,6.56,1.61,8.96-.79l5.62-5.62c3.45,2.95,6.66,6.16,9.61,9.61l-5.63,5.65c-2.4,2.4-2.72,6.18-.78,8.96,6.01,8.57,9.99,18.16,11.82,28.5.59,3.34,3.5,5.78,6.89,5.78h7.96c.18,2.25.26,4.52.26,6.8s-.09,4.54-.26,6.77h0ZM335.87,339.99c-29.9,0-54.23,24.33-54.23,54.23s24.33,54.23,54.23,54.23,54.23-24.33,54.23-54.23-24.33-54.23-54.23-54.23ZM335.87,434.44c-22.18,0-40.22-18.04-40.22-40.22s18.04-40.22,40.22-40.22,40.22,18.04,40.22,40.22-18.04,40.22-40.22,40.22ZM103.12,205.4c0-13.2-9.08-24.32-21.32-27.44v-89.01c0-3.87-3.13-7-7-7s-7,3.13-7,7v89.01c-12.22,3.13-21.29,14.24-21.29,27.44s9.06,24.29,21.29,27.41v10.03c0,3.87,3.13,7,7,7s7-3.13,7-7v-10.03c12.24-3.12,21.32-14.23,21.32-27.41h0ZM60.51,205.4c0-7.89,6.41-14.31,14.29-14.31s14.31,6.42,14.31,14.31-6.42,14.29-14.31,14.29-14.29-6.41-14.29-14.29ZM219.62,224.65v18.2c0,3.87,3.13,7,7,7s7-3.13,7-7v-18.2c12.24-3.12,21.32-14.24,21.32-27.44s-9.08-24.29-21.32-27.41v-80.84c0-3.87-3.13-7-7-7s-7,3.13-7,7v80.84c-12.22,3.12-21.29,14.23-21.29,27.41s9.06,24.31,21.29,27.44ZM226.62,182.92c7.89,0,14.31,6.41,14.31,14.29s-6.42,14.31-14.31,14.31-14.29-6.42-14.29-14.31,6.41-14.29,14.29-14.29ZM295.53,147.6v95.24c0,3.87,3.13,7,7,7s7-3.13,7-7v-95.24c12.24-3.12,21.32-14.23,21.32-27.41s-9.08-24.29-21.32-27.41v-3.82c0-3.87-3.13-7-7-7s-7,3.13-7,7v3.83c-12.22,3.12-21.29,14.23-21.29,27.41s9.06,24.29,21.29,27.41h0ZM302.53,105.9c7.89,0,14.31,6.41,14.31,14.29s-6.42,14.29-14.31,14.29-14.29-6.41-14.29-14.29,6.41-14.29,14.29-14.29ZM60.39,66.84h28.8c3.87,0,7-3.13,7-7v-28.8c0-3.87-3.13-7-7-7h-28.8c-3.87,0-7,3.13-7,7v28.8c0,3.87,3.13,7,7,7ZM67.39,38.04h14.8v14.8h-14.8v-14.8ZM136.3,66.84h28.8c3.87,0,7-3.13,7-7v-28.8c0-3.87-3.13-7-7-7h-28.8c-3.87,0-7,3.13-7,7v28.8c0,3.87,3.13,7,7,7ZM143.3,38.04h14.8v14.8h-14.8v-14.8ZM212.21,66.84h28.8c3.87,0,7-3.13,7-7v-28.8c0-3.87-3.13-7-7-7h-28.8c-3.87,0-7,3.13-7,7v28.8c0,3.87,3.13,7,7,7ZM219.21,38.04h14.8v14.8h-14.8v-14.8ZM288.12,66.84h28.8c3.87,0,7-3.13,7-7v-28.8c0-3.87-3.13-7-7-7h-28.8c-3.87,0-7,3.13-7,7v28.8c0,3.87,3.13,7,7,7ZM295.12,38.04h14.8v14.8h-14.8v-14.8ZM182.05,309.06c-3.17,0-6.18.65-8.93,1.81v-21.51h201.57c1.88,0,3.67-.75,4.99-2.09s2.04-3.15,2.01-5.02l-4.37-275.36c-.06-3.82-3.18-6.89-7-6.89H7C3.13,0,0,3.13,0,7v275.44c0,3.87,3.13,7,7,7h88.3v3.89c-2.75-1.17-5.78-1.82-8.96-1.82-12.66,0-22.96,10.3-22.96,22.96v5.99c-2.75-1.17-5.78-1.82-8.96-1.82-12.64,0-22.93,10.3-22.93,22.96v43.62c0,21.27,7.98,41.73,21.93,57.49h-2.66c-3.87,0-7,3.13-7,7v37.3c0,3.87,3.13,7,7,7h134.99c3.87,0,7-3.13,7-7v-37.3c0-3.87-3.13-7-7-7h-2.66c13.95-15.75,21.93-36.22,21.93-57.49v-53.21c0-12.66-10.3-22.96-22.96-22.96h-.01ZM14,14.01h349.45l4.14,261.35h-194.46v-35.86c0-10.02-6.45-18.56-15.42-21.68v-27.61c12.24-3.12,21.32-14.23,21.32-27.41s-9.08-24.32-21.32-27.44v-46.4c0-3.87-3.13-7-7-7s-7,3.13-7,7v46.4c-12.22,3.13-21.29,14.24-21.29,27.44s9.06,24.29,21.29,27.41v27.27c-9.52,2.8-16.5,11.61-16.5,22.03v20.33c-2.75-1.17-5.78-1.82-8.96-1.82-10.75,0-19.8,7.44-22.28,17.43H14V14.01ZM150.71,148.49c7.89,0,14.31,6.42,14.31,14.31s-6.42,14.29-14.31,14.29-14.29-6.41-14.29-14.29,6.41-14.31,14.29-14.31ZM178.74,480.03H57.76v-23.3h120.98v23.3ZM191.01,385.24c0,22.37-10.54,43.69-28.3,57.49h-88.92c-17.76-13.8-28.3-35.12-28.3-57.49v-43.62c0-4.94,4-8.96,8.93-8.96s8.96,4.02,8.96,8.96c0,3.87,3.13,7,7,7s7-3.13,7-7v-27.13c0-4.86,4.1-8.96,8.96-8.96s8.96,4.02,8.96,8.96c0,3.87,3.13,7,7,7s7-3.13,7-7v-33.51c0-4.94,4.02-8.96,8.96-8.96s8.96,4.02,8.96,8.96v48.53c0,3.87,3.13,7,7,7s7-3.13,7-7v-90c0-4.94,4.02-8.96,8.96-8.96s8.96,4.02,8.96,8.96v92.52c0,3.87,3.13,7,7,7s7-3.13,7-7c0-4.94,4-8.96,8.93-8.96s8.96,4.02,8.96,8.96v53.21h-.02Z"
    />
  </svg>
);

export const PaymentDetailsSvgIcon = ({
  fill = "#00bfff",
  size = 25,
  ...props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 507.9 508"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={fill}
      d="M121.5,347.7h-37.3c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h19.4v9.2c0,7.8,6.3,14.1,14.1,14.1s14.1-6.3,14.1-14.1v-10.5c19.2-4.7,33.6-22,33.6-42.6,0-24.2-19.7-43.9-44-43.9l-7.4.1c-8.7,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7h37.3c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-19.4v-9.2c0-7.8-6.3-14.1-14.1-14.1s-14.1,6.3-14.1,14.1v10.5c-19.2,4.7-33.6,22-33.6,42.6,0,24.2,19.7,43.9,44,43.9l7.4-.1c8.7,0,15.7,7,15.7,15.7s-7.1,15.7-15.7,15.7Z"
    />
    <path
      fill={fill}
      d="M465.7,0H42.3C19,0,0,19,0,42.3v423.3c0,23.4,19,42.4,42.3,42.4h423.3c23.3,0,42.3-19,42.3-42.3V42.3c.1-23.3-18.9-42.3-42.2-42.3h0ZM479.8,465.7c0,7.8-6.3,14.1-14.1,14.1H42.3c-7.8,0-14.1-6.3-14.1-14.1V131h451.6v334.7ZM479.8,102.7H28.2v-60.4c0-7.8,6.3-14.1,14.1-14.1h423.3c7.8,0,14.1,6.3,14.1,14.1v60.4h.1Z"
    />
    <path
      fill={fill}
      d="M329.7,54h-26.4c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h26.4c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1Z"
    />
    <path
      fill={fill}
      d="M432.5,54h-26.4c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h26.4c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1Z"
    />
    <path
      fill={fill}
      d="M248.4,205.7h185.4c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-185.4c-7.8,0-14.1,6.3-14.1,14.1-.1,7.8,6.3,14.1,14.1,14.1Z"
    />
    <path
      fill={fill}
      d="M248.4,280.7h185.4c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-185.4c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1Z"
    />
    <path
      fill={fill}
      d="M248.4,355.7h185.4c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-185.4c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1Z"
    />
    <path
      fill={fill}
      d="M248.4,430.8h110.4c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-110.4c-7.8,0-14.1,6.3-14.1,14.1-.1,7.7,6.3,14.1,14.1,14.1Z"
    />
  </svg>
);

export const CategoryCreationSvgIcon = ({
  fill = "#00bfff",
  size = 28,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 300"
    width={size}
    height={size}
    {...props}
  >
    <clipPath id="clip">
      <rect width="300" height="300" />
    </clipPath>

    <g clipPath="url(#clip)">
      <path
        d="M112.5,150c0-20.71,16.79-37.5,37.5-37.5s37.5,16.79,37.5,37.5-16.79,37.5-37.5,37.5-37.5-16.79-37.5-37.5Z"
        stroke={fill}
        strokeWidth={25}
        strokeMiterlimit={125}
        fill="none"
      />

      <path
        d="M87.5,287.5c0-34.52,27.97-62.5,62.5-62.5s62.5,27.97,62.5,62.5"
        stroke={fill}
        strokeWidth={25}
        strokeLinecap="round"
        strokeMiterlimit={125}
        fill="none"
      />

      <path
        d="M187.5,50c0-20.71,16.79-37.5,37.5-37.5s37.5,16.79,37.5,37.5-16.79,37.5-37.5,37.5-37.5-16.79-37.5-37.5Z"
        stroke={fill}
        strokeWidth={25}
        strokeMiterlimit={125}
        fill="none"
      />

      <path
        d="M225,125c34.52,0,62.5,27.97,62.5,62.5"
        stroke={fill}
        strokeWidth={25}
        strokeLinecap="round"
        strokeMiterlimit={125}
        fill="none"
      />

      <path
        d="M112.5,50c0-20.71-16.79-37.5-37.5-37.5s-37.5,16.79-37.5,37.5,16.79,37.5,37.5,37.5,37.5-16.79,37.5-37.5Z"
        stroke={fill}
        strokeWidth={25}
        strokeMiterlimit={125}
        fill="none"
      />

      <path
        d="M75,125c-34.52,0-62.5,27.97-62.5,62.5"
        stroke={fill}
        strokeWidth={25}
        strokeLinecap="round"
        strokeMiterlimit={125}
        fill="none"
      />
    </g>
  </svg>
);

export const DownloadSvgIcon = ({ fill = "#fff", size = 16, ...props }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={fill}
      d="M233.38,389.01c6.24,6.26,14.43,9.38,22.62,9.38s16.38-3.12,22.62-9.38l110.38-110.38c12.5-12.5,12.5-32.75,0-45.25-12.48-12.5-32.77-12.5-45.25,0l-55.76,55.76V32c0-17.66-14.34-32-32-32s-32,14.34-32,32v257.14l-55.76-55.76c-12.48-12.5-32.77-12.5-45.25,0-12.5,12.5-12.5,32.75,0,45.25l110.38,110.38Z"
    />
    <path
      fill={fill}
      d="M480,336c-17.66,0-32,14.34-32,32v48c0,17.65-14.35,32-32,32H96c-17.65,0-32-14.35-32-32v-48c0-17.66-14.34-32-32-32S0,350.34,0,368v48c0,52.94,43.06,96,96,96h320c52.94,0,96-43.06,96-96v-48c0-17.66-14.34-32-32-32Z"
    />
  </svg>
);

export const EditSvgIcon = ({ fill = "#fff", size = 19, ...props }) => (
  <svg
    id="Capa_1"
    data-name="Capa 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 347.37 348.88"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={fill}
      d="M333.23,11.76l-.42-.38c-8.03-7.34-18.44-11.38-29.31-11.38-12.19,0-23.89,5.16-32.1,14.15L116.05,184.23c-1.42,1.55-2.49,3.38-3.15,5.37l-18.27,54.76c-2.11,6.33-1.05,13.33,2.83,18.73,3.92,5.44,10.23,8.68,16.89,8.68h0c2.88,0,5.69-.59,8.36-1.76l52.89-23.14c1.92-.84,3.65-2.08,5.06-3.63l155.35-170.08c16.17-17.7,14.92-45.25-2.78-61.42ZM129.62,234.25l10.72-32.13.9-.99,20.32,18.56-.9.99-31.03,13.58ZM313.86,52.94l-132.07,144.59-20.32-18.56L293.55,34.39c2.58-2.83,6.12-4.39,9.95-4.39,3.36,0,6.59,1.25,9.08,3.53l.42.38c5.48,5.01,5.87,13.55.86,19.03Z"
    />
    <path
      fill={fill}
      d="M303.09,138.39c-8.28,0-15,6.72-15,15v127.35c0,21.03-17.11,38.15-38.15,38.15H68.15c-21.03,0-38.15-17.11-38.15-38.15V100.41c0-21.03,17.11-38.15,38.15-38.15h131.59c8.28,0,15-6.72,15-15s-6.72-15-15-15H68.15C30.57,32.27,0,62.84,0,100.41v180.32c0,37.58,30.57,68.15,68.15,68.15h181.8c37.58,0,68.15-30.57,68.15-68.15v-127.35c0-8.28-6.71-15-15-15Z"
    />
  </svg>
);

export const DeleteSvgIcon = ({ fill = "#fff", size = 19, ...props }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 426.67"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={fill}
      d="M149.33,341.33c-12.8,0-21.33-8.53-21.33-21.33v-106.67c0-12.8,8.53-21.33,21.33-21.33s21.33,8.53,21.33,21.33v106.67c0,12.8-8.53,21.33-21.33,21.33Z"
    />
    <path
      fill={fill}
      d="M234.67,341.33c-12.8,0-21.33-8.53-21.33-21.33v-106.67c0-12.8,8.53-21.33,21.33-21.33s21.33,8.53,21.33,21.33v106.67c0,12.8-8.53,21.33-21.33,21.33Z"
    />
    <path
      fill={fill}
      d="M362.67,128H21.33c-12.8,0-21.33-8.53-21.33-21.33s8.53-21.33,21.33-21.33h341.33c12.8,0,21.33,8.53,21.33,21.33s-8.53,21.33-21.33,21.33Z"
    />
    <path
      fill={fill}
      d="M256,426.67h-128c-46.93,0-85.33-38.4-85.33-85.33v-170.67c0-12.8,8.53-21.33,21.33-21.33s21.33,8.53,21.33,21.33v170.67c0,23.47,19.2,42.67,42.67,42.67h128c23.47,0,42.67-19.2,42.67-42.67v-170.67c0-12.8,8.53-21.33,21.33-21.33s21.33,8.53,21.33,21.33v170.67c0,46.93-38.4,85.33-85.33,85.33Z"
    />
    <path
      fill={fill}
      d="M256,128h-128c-12.8,0-21.33-8.53-21.33-21.33v-42.67C106.67,27.73,134.4,0,170.67,0h42.67c36.27,0,64,27.73,64,64v42.67c0,12.8-8.53,21.33-21.33,21.33ZM149.33,85.33h85.33v-21.33c0-12.8-8.53-21.33-21.33-21.33h-42.67c-12.8,0-21.33,8.53-21.33,21.33v21.33Z"
    />
  </svg>
);
export const DosandDontsIcon = ({ fill = "#00bfff", size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path fill={fill} d="M11 7h2V9h-2zm0 4h2v6h-2z" />
    <path
      fill={fill}
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
         10-4.48 10-10S17.52 2 12 2zm0 18
         c-4.41 0-8-3.59-8-8s3.59-8 8-8
         8 3.59 8 8-3.59 8-8 8z"
    />
  </svg>
);
export const ActiveSimulation = ({ fill = "#00bfff", size = 34, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 302 302"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={fill}
      d="M175,150c0,13.8-11.2,25-25,25s-25-11.2-25-25,11.2-25,25-25,25,11.2,25,25ZM256.1,43.9l-17.6,17.6c48.7,48.7,48.7,128,0,176.8l17.6,17.6c58.5-58.5,58.5-153.6,0-212.1ZM194.2,105.8c11.7,11.7,18.3,27.5,18.3,44.2s-6.5,32.4-18.3,44.2l17.6,17.6c16.5-16.5,25.6-38.5,25.6-61.9s-9.1-45.4-25.6-61.9l-17.6,17.6ZM43.9,43.9c-58.4,58.5-58.4,153.8,0,212.2l17.6-17.6c-48.8-48.7-48.8-128,0-176.8l-17.6-17.6ZM88.1,88.1c-34.1,34.1-34.1,89.6,0,123.8l17.6-17.6c-24.4-24.4-24.4-64,0-88.4l-17.6-17.6Z"
    />
  </svg>
);

export const PastSimulation = ({ fill = "#00bfff", size = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    {...props}
  >
    <g transform="matrix(1.3333333,0,0,-1.3333333,0,32)">
      <g>
        <g transform="translate(12,24)">
          <path
            fill={fill}
            d="M0,0C2.973,0 5.817,-1.127 8,-3.078V0h2V-5.143C10,-6.167 9.167,-7 8.143,-7H3v2H7.121C5.254,-3.107 2.689,-2 0,-2c-5.514,0 -10,-4.486 -10,-10 0,-5.514 4.486,-10 10,-10 5.514,0 10,4.486 10,10h2c0,-6.617 -5.383,-12 -12,-12 -6.617,0 -12,5.383 -12,12 0,6.617 5.383,12 12,12"
          />
        </g>
        <g transform="translate(11,17)">
          <path
            fill={fill}
            d="M0,0V-5.414L3.293,-8.707 4.707,-7.293 2,-4.586V0Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SupplementarymaterialforinstructorIcon = ({
  fill = "#00bfff",
  size = 32,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <g transform="matrix(1,0,0,1,0,0)">
      <g transform="matrix(1.3333333,0,0,-1.3333333,0,32)">
        <g>
          <g clipPath="url(#clipPath167)">
            <g transform="translate(12,17.8921)">
              <path
                d="m 0,0 c 0,1.45 -1.037,2.692 -2.463,2.952 l -6.18,1.123 C -9.87,4.298 -11,3.355 -11,2.107 v -15.999 l 11,-2 11,2 V 2.107 C 11,3.355 9.87,4.298 8.643,4.075 L 2.463,2.952 C 1.037,2.692 0,1.45 0,0 v -15.892"
                fill="none"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clipPath167">
            <path d="M 0,24 H 24 V 0 H 0 Z" />
          </clipPath>
        </defs>
      </g>
    </g>
  </svg>
);

export const SetupSimulationIcon = ({
  fill = "#00bfff",
  size = 32,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="m13.3 9.862 1.411-.813c.605.652 1.393 1.125 2.289 1.33v1.621h2v-1.621c.896-.205 1.685-.678 2.289-1.33l1.411.813.998-1.733-1.416-.816c.129-.418.218-.853.218-1.313s-.089-.895-.218-1.313l1.416-.816-.998-1.733-1.411.813c-.605-.652-1.393-1.125-2.289-1.33v-1.621h-2v1.621c-.896.205-1.685.678-2.289 1.33l-1.411-.813-.998 1.733 1.416.816c-.129.418-.218.853-.218 1.313s.089.895.218 1.313l-1.416.816zm4.7-6.362c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5zm6 8.472v8.028h-11v2h5v2h-12v-2h5v-2h-11v-15c0-1.654 1.346-3 3-3h7.298c-.387.617-.689 1.29-.908 2h-6.39c-.551 0-1 .449-1 1v13h20v-4.305c.752-.47 1.431-1.047 2-1.723z"
      fill={fill}
    />
  </svg>
);

export const SettingIcon = ({ fill = "#00bfff", size = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M15,24c-.553,0-1-.447-1-1v-1.398c0-1.505,.805-2.853,2.1-3.516,3.022-1.55,4.9-4.62,4.9-8.013,0-3.455-1.928-6.55-5.03-8.078l.03,6.005c0,2.206-1.794,4-4,4s-4-1.794-4-4V2.012C4.928,3.523,3,6.618,3,10.073c0,3.393,1.878,6.463,4.9,8.013,1.295,.663,2.1,2.011,2.1,3.516v1.398c0,.553-.447,1-1,1s-1-.447-1-1v-1.398c0-.739-.397-1.421-1.012-1.736-3.693-1.894-5.988-5.646-5.988-9.792C1,5.852,3.355,2.068,7.146,.2c.61-.3,1.321-.263,1.901,.101,.597,.371,.953,1.011,.953,1.711v5.988c0,1.103,.897,2,2,2s2-.897,2-2V2.012c0-.7,.356-1.34,.953-1.711,.581-.362,1.293-.399,1.9-.101,3.791,1.868,6.146,5.651,6.146,9.873,0,4.146-2.295,7.898-5.988,9.792-.614,.315-1.012,.997-1.012,1.736v1.398c0,.553-.447,1-1,1Z"
      fill={fill}
    />
  </svg>
);

export const GroupConnectivityIcon = ({
  color = "#00bfff",
  size = 32,
  ...props
}) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Center Node */}
    <g transform="translate(12,16)">
      <circle cx="3" cy="0" r="3" stroke={color} strokeWidth="2" fill="none" />
    </g>

    {/* Top Node */}
    <g transform="translate(20,12)">
      <circle cx="3" cy="0" r="3" stroke={color} strokeWidth="2" fill="none" />
    </g>
    <g transform="translate(23,6)">
      <path
        d="M 0,0 C 2.762,0 5,-2.238 5,-5"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </g>

    {/* Left Node */}
    <g transform="translate(12,12)">
      <circle cx="-3" cy="0" r="3" stroke={color} strokeWidth="2" fill="none" />
    </g>
    <g transform="translate(9,6)">
      <path
        d="M 0,0 C -2.762,0 -5,-2.238 -5,-5"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </g>

    {/* Top Antenna Wave */}
    <g transform="translate(10,1)">
      <path
        d="M 0,0 C 0,2.762 2.238,5 5,5 7.762,5 10,2.762 10,0"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
